export default {"src":"/_next/static/media/client-01.f017758b.svg","height":21,"width":110,"blurWidth":0,"blurHeight":0};